import { defineAsyncComponent } from 'vue'
export default {
  application: defineAsyncComponent(() => import("/app/layouts/application.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m))
}